import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert, useBlastAI } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';

interface PostBlastAIUserConversationProps {
    userPrompt: string;
    token: string;
    conversationId?: string;
}

export const postBlastAIUserConversation: MutationFunction<
    AxiosResponse<any>,
    PostBlastAIUserConversationProps
> = async (props: PostBlastAIUserConversationProps) => {
    const { userPrompt, token, conversationId } = props;
    const headers = getDefaultHeaders(token);
    const url = 'blastai/conversation/user';

    return axiosInstance().post(
        url,
        {
            userPrompt,
            conversationId,
            approvalToUseMetadata: true,
        },
        withHeaders(headers)
    );
};

export const useBlastAIUserConversation = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostBlastAIUserConversationProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const { handleNewSystemMessage } = useBlastAI();

    return useMutation(postBlastAIUserConversation, {
        onSuccess: (response) => {
            const systemResponse = response.data?.answer ?? '';
            const conversationId = response.data?.conversationId;
            handleNewSystemMessage(conversationId, systemResponse, 'blast');
        },
        onError: (error: any) => {
            const conversationId = error?.id;
            const unauthorizedStatusCode = 401;

            // according to the error object, we could have the status via two different ways to better to check both.
            const isUnauthorizedErrorStatus =
                error?.status === unauthorizedStatusCode ||
                error?.data?.status === unauthorizedStatusCode;

            // Set the default message if there's no error or the error came as an unauthorized error. Otherwise, display the actual error.
            const errorMessage: string =
                isUnauthorizedErrorStatus || !error?.data?.message
                    ? 'Failed to retrieve user message. Please try again.'
                    : error?.data?.message;

            handleNewSystemMessage(conversationId, errorMessage, 'error');
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
